import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { API, get } from 'utils/api';
import { createReducer } from 'utils/redux';

import type { Action, ResponseTime, ThunkAction } from 'types';

const SET_LOADING_STATUS = 'influencerResponseData/setLoadingState';
const SET_RESPONSE_DATA = 'influencerResponseData/setResponseData';

const initialState = {
  responseTimeData: {},
  loadingStatus: false
};

function setLoadingStatus(loadingStatus: boolean): Action {
  return {
    type: SET_LOADING_STATUS,
    payload: {
      loadingStatus
    }
  };
}

function setData(
  data: {
    [x: number]: ResponseTime
  }
): Action {
  return {
    type: SET_RESPONSE_DATA,
    payload: {
      data
    }
  };
}

export function fetchInfluencerResponseTime(ids: Array<number>): ThunkAction {
  return async (dispatch) => {
    try {
      dispatch(setLoadingStatus(true));
      const url = API.END_POINTS.INFLUENCERS.getInfluencersResponseTime(ids);
      const result = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(setData(result.data));
    } catch (error) {
      // nothing to do here
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export function fetchInfluencerSelfResponseTime(id: number): ThunkAction {
  return async (dispatch) => {
    try {
      dispatch(setLoadingStatus(true));
      const url = API.END_POINTS.INFLUENCERS.getInfluencerSelfResponseTime(id);
      const result = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(setData({ [id]: result.data }));
    } catch (error) {
      // nothing to do here
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export default createReducer<any, any>('influencerResponseTime', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [SET_LOADING_STATUS]: (state, { loadingStatus }) => ({
    ...state,
    loadingStatus
  }),
  [SET_RESPONSE_DATA]: (state, { data = {} }) => ({
    ...state,
    responseTimeData: {
      ...state.responseTimeData,
      ...data
    }
  })
});
